import { PageHeader, Card } from "@/components/dash";

const ENDPOINTS = [
  ["POST", "/api/payments", "Ödeme oluştur"],
  ["GET", "/api/payments/:id", "Ödeme getir"],
  ["GET", "/api/payments/:id/status", "Ödeme durumu"],
  ["GET", "/api/payments", "Ödemeleri listele"],
  ["POST", "/api/payment-links", "Ödeme linki oluştur"],
  ["POST", "/api/payouts", "Para çekme (payout)"],
  ["POST", "/api/webhooks", "Webhook ekle"],
];

const METHOD_CLS = { GET: "bg-emerald-500/10 text-emerald-500", POST: "bg-primary/10 text-primary" };

export default function DevelopersPanel() {
  return (
    <div>
      <PageHeader title="Geliştiriciler" desc="Coinbuy REST API endpoint referansı." />
      <Card className="p-6 mb-6">
        <h3 className="text-base font-bold">Kimlik Doğrulama</h3>
        <p className="mt-2 text-sm text-muted-foreground">Her istekte <code className="rounded bg-muted px-1.5 py-0.5 text-xs">Authorization: Bearer &lt;Secret Key&gt;</code> başlığını gönderin. Base URL: <code className="rounded bg-muted px-1.5 py-0.5 text-xs">{process.env.REACT_APP_BACKEND_URL}/api</code></p>
      </Card>
      <Card className="overflow-hidden">
        <table className="w-full text-sm">
          <tbody className="divide-y divide-border">
            {ENDPOINTS.map(([m, path, desc]) => (
              <tr key={path} className="hover:bg-muted/30">
                <td className="px-4 py-3 w-16"><span className={`text-xs font-bold px-2 py-1 rounded ${METHOD_CLS[m]}`}>{m}</span></td>
                <td className="px-4 py-3 font-mono text-xs">{path}</td>
                <td className="px-4 py-3 text-muted-foreground">{desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
